import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';

export default class Document extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            controllerName: 'document',
            data: null,
            loading: true,
            t_bed: 0,
            t_bes: 0,
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/document/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    window.organizationId = data.global.company.id;
                    this.state.data = data;
                    this.state.loading = false;
                    this.updateFormula();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        this.httpPost("api/v1/document/save", {
            id: this.state.id,
            number: this.state.data.record.number,
            organizationId: this.state.data.global.company.id,
            number2: this.state.data.record.number2,
            description: this.state.data.record.description,
            date: this.convertMomentToDb(this.state.data.record.date),
            note: this.state.data.record.note,
            status: this.state.data.record.status,
            type: this.state.data.record.type,
            bodies: this.state.data.bodies,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("سند با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setBodyValue(id, field, value) {
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].id === id) {
                if (field == 'moeinCode' || field == 'tafsilCode') {
                    this.state.data.bodies[i][field] = value.value;
                    if (field == 'moeinCode') this.state.data.bodies[i]['moeinName'] = value.label;
                    if (field == 'tafsilCode') this.state.data.bodies[i]['tafsilName'] = value.label;
                }
                else {
                    this.state.data.bodies[i][field] = value;
                }

                if (field == 'moeinCode') {
                    this.state.data.bodies[i]['moeinDetailed'] = value.moeinDetailed;
                    if (!value.moeinDetailed) {
                        this.state.data.bodies[i]['tafsilCode'] = 0;
                        this.state.data.bodies[i]['tafsilName'] = '';
                    }
                }

                if (this.isBlank(this.state.data.bodies[i]["bed"])) this.state.data.bodies[i]["bed"] = 0;
                if (this.isBlank(this.state.data.bodies[i]["bes"])) this.state.data.bodies[i]["bes"] = 0;
            }
        }
        this.updateFormula();
    }
    updateFormula() {
        this.state.t_bed = 0;
        this.state.t_bes = 0;
        var hasBlankRow = false;
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].moeinCode == 0) hasBlankRow = true;

            this.state.t_bed = this.FixedPointNumber(this.state.data.bodies[i]["bed"] + this.state.t_bed);
            this.state.t_bes = this.FixedPointNumber(this.state.data.bodies[i]["bes"] + this.state.t_bes);
        }
        if (!hasBlankRow) this.addBlankRow();

        this.setState({ date: this.state.data });
    }
    addBlankRow() {
        this.state.data.bodies.push(this.getBlankRow());
    }
    getBlankRow(defaultIndex = null) {
        return {
            id: this.uuidv4(),
            index: (defaultIndex == null ? this.state.data.bodies.length + 1 : defaultIndex),
            moeinCode: 0,
            moeinName: '',
            tafsilCode: 0,
            tafsilName: '',
            bed: 0,
            bes: 0,
            description: ''
        }
    }
    removeRow(id) {
        var temp = [];
        var index = 1;
        this.state.data.bodies.sort((a, b) => a.index - b.index).forEach(r => {
            if (r.id != id) {
                temp.push(r);
                temp[temp.length - 1].index = index;
                index++;
            }
        });
        this.state.data.bodies = temp;
        this.updateFormula();
    }
    copyRow(id) {
        var clone = null;
        this.state.data.bodies.forEach(i => {
            if (i.id === id) {
                clone = Object.assign({}, i);
            }
        });
        clone.id = this.uuidv4();
        var startIndex = clone.index;
        for (var i = 0; i < this.state.data.bodies.length; i++) {
            if (this.state.data.bodies[i].index > startIndex) this.state.data.bodies[i].index++;
        }
        clone.index++;
        this.state.data.bodies.push(clone);
        this.updateFormula();
    }

    upIndex(id) {
        var idIndex = -1;
        this.state.data.bodies.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex > 0) {
            var ii = this.state.data.bodies[idIndex].index;
            this.state.data.bodies[idIndex].index = ii - 1;
            this.state.data.bodies[idIndex - 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    downIndex(id) {
        var idIndex = -1;
        this.state.data.bodies.forEach((r, index) => {
            if (r.id == id) idIndex = index;
        });
        if (idIndex != -1 && idIndex < this.state.data.bodies.length - 1) {
            var ii = this.state.data.bodies[idIndex].index;
            this.state.data.bodies[idIndex].index = ii + 1;
            this.state.data.bodies[idIndex + 1].index = ii;
            this.setState({ data: this.state.data });
        }
    }
    renderForm() {
        return <div className="modal fade in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog modal-lg" role="document" style={{ "width": "96%" }}>
                <div className="modal-content">
                    <div className="modal-body" id="DocumentModalViewerContent" style={{ "padding": "0px" }}>
                        <div className="panel panel-info center-block" style={{ "max-width": " none" }}>
                            <div className="panel-heading">
                                <span className="panel-title">سند حسابداری</span>
                            </div>
                            <div className="panel-body">
                                <div className="row">
                                    <div className="col-sm-4">
                                        <div className="form-group">
                                            <label for="documentDescription" className="title1">شرح</label>
                                            <input onChange={e => this.state.data.record.description = e.target.value} defaultValue={this.state.data.record.description} autocomplete="off" type="text" className="form-control input-sm ng-valid" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="documentDate" className="title1">تاریخ<span className="red">*</span></label>
                                            <DatePicker
                                                inputReadOnly={true}
                                                className="form-control input-sm persian-date"
                                                placeholder={"تاریخ"}
                                                isGregorian={false}
                                                showTodayButton={true}
                                                timePicker={false}
                                                onChange={(e) => { this.state.data.record.date = e }}
                                                value={this.getFormatedDateForDatePicker(this.state.data.record.date)}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="documentId" className="title1">شماره سند</label>
                                            <input onChange={e => this.state.data.record.number = parseInt(e.target.value)} defaultValue={this.state.data.record.number} autocomplete="off" type="text" className="form-control input-sm ng-valid" disabled="disabled" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="title1">شماره عطف</label>
                                            <input onChange={e => this.state.data.record.number2 = parseInt(e.target.value)} defaultValue={this.state.data.record.number2} autocomplete="off" type="text" className="form-control input-sm ng-valid" disabled="disabled" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label className="title1">وضعیت</label>
                                            <select onChange={e => this.state.data.record.status = parseInt(e.target.value)} defaultValue={this.state.data.record.status} autocomplete="off" type="text" className="form-control input-sm ng-valid">
                                                <option value="2">موقت</option>
                                                <option value="3">قطعی</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="separator1"></div>
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr className="active" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                            <td></td>
                                            <td>معین</td>
                                            <td>تفصیلی</td>
                                            <td>شرح</td>
                                            <td>بدهکار <span style={{ "font-weight": "normal" }} > ({this.state.data.global.company.currencyUnit})</span></td>
                                            <td>بستانکار <span style={{ "font-weight": "normal" }} > ({this.state.data.global.company.currencyUnit})</span></td>
                                            <td></td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.data.bodies.sort((a, b) => a.index - b.index).map((item, index) =>
                                            <tr key={item.id} className="accDataEntryGridRow invoice_grid_row" style={{ "font-size": "9pt", "font-weight": "bold" }}>
                                                <td>
                                                    <span className="inGridRowNumber">{(index + 1)}</span>
                                                    <div style={{
                                                        "font-size": "9pt", "color": "silver"
                                                    }}>
                                                        {index > 0 && index != this.state.data.bodies.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
                                                        {index < this.state.data.bodies.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
                                                    </div>
                                                </td>
                                                <td>
                                                    <SelectAsync
                                                        style={{ "width": "100%" }}
                                                        defaultValue={item.moeinCode > 0 ? [{ value: item.moeinCode, label: item.moeinName }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب حساب معین"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                        onChange={e => this.setBodyValue(item.id, 'moeinCode', e)}
                                                    />
                                                </td>
                                                <td>
                                                    {item.moeinDetailed && <SelectAsync
                                                        style={{ "width": "100%" }}
                                                        defaultValue={item.tafsilCode > 0 ? [{ value: item.tafsilCode, label: item.tafsilName }] : null}
                                                        isMulti={false}
                                                        placeholder="انتخاب حساب تفصیل"
                                                        defaultOptions
                                                        loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, item.moeinCode)}
                                                        onChange={e => this.setBodyValue(item.id, 'tafsilCode', e)}
                                                    />
                                                    }
                                                </td>
                                                <td><input onChange={e => this.setBodyValue(item.id, 'description', e.target.value)} defaultValue={item.description} autocomplete="off" type="text" className="form-control input-sm ng-valid" /></td>
                                                <td style={{ "width": "150px" }}><NumberFormat value={item.bed} onChange={e => this.setBodyValue(item.id, 'bed', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control' /></td>
                                                <td style={{ "width": "150px" }}><NumberFormat value={item.bes} onChange={e => this.setBodyValue(item.id, 'bes', (this.isBlank(e.target.value.replace(/,/g, '')) ? 0 : parseFloat(e.target.value.replace(/,/g, ''))))} thousandSeparator={true} prefix={''} className='form-control' /></td>
                                                <td>
                                                    {item.moeinCode != 0 && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
                                                    {item.moeinCode != 0 && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <div className="row" style={{ "padding-left": "15px" }} >
                                    <div className="col-md-7">
                                        <div className="form-group" style={{ "padding-left": "50px" }} >
                                            <label className="title1" for="comment">یادداشت</label>
                                            <textarea onChange={e => this.state.data.record.note = e.target.value} defaultValue={this.state.data.record.note} className="form-control ng-pristine ng-untouched ng-valid" rows="4" maxlength="250"></textarea>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="row text-left bg-info" style={{ "border-bottom": "1px solid rgb(69, 69, 69)", "padding-left": "44px" }} >
                                            <div className="col-xs-6 h5 txt-bold text-right">مجموع <span style={{ "font-weight": "normal" }} > ({this.state.data.global.company.currencyUnit})</span></div>
                                            <div className="col-xs-3 h5 txt-bold" id="documentTotalBed" style={{ "text-align": "center", "width": "120px", "padding": "0" }}>{this.money(this.state.t_bed)}</div>
                                            <div className="col-xs-3 h5 txt-bold" id="documentTotalBes" style={{ "text-align": "center", "width": "120px", "padding": "0" }}>{this.money(this.state.t_bes)}</div>
                                        </div >
                                        <div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "10px" }} ></div>
                                        <div className="row text-left" id="documentDeffShow">
                                            <div className="col-xs-4 title1 text-right">اختلاف <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
                                            <div className="col-xs-8 title1 text-center">{this.money(this.state.t_bed - this.state.t_bes)}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="panel-footer">
                                <div className="row">
                                    <div className="col-xs-8 text-right">
                                        <button type="button" className="btn btn-primary" onClick={e => this.save(e)}>ذخیره</button>
                                        &nbsp;
                                        {this.state.data.record.id !== this.defaultGuid() && [
                                            <a className="hand btn btn-default" style={{ "marginRight": "10px" }} onClick={e => this.exportFromUrl('print', '/api/v1/document/export/' + this.state.data.record.id)}>
                                                <span className="fa fa-print" aria-hidden="true"></span>&nbsp;
                                                چاپ
                                            </a>
                                            ,
                                            <a className="hand btn btn-default" style={{ "marginRight": "10px" }} onClick={e => this.exportFromUrl('pdf', '/api/v1/document/export/' + this.state.data.record.id)}>
                                                <span className="fa fa-file-pdf-o" aria-hidden="true"></span>&nbsp;
                                                PDF
                                            </a>
                                        ]
                                        }
                                    </div>
                                    <div className="col-xs-4 text-left">
                                        <a className="btn btn-default btn-smoke" style={{ "width": "80px" }} onClick={e => this.closeMe()} > انصراف</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent()
            ];

        return contents;
    }
}